<div class="component-viewer">
    <mat-card>
        <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="15" [updateFilterEvent]="updateFilterEvent"
            [filter]="filter" [data]="registrations" (filterChanged)="getRegistrations()" (filterReset)="resetFilter()">
        </gt-table>
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        <table mat-table class="registrations-list__table" [dataSource]="registrations" matSort (matSortChange)="sortData($event)">
            <ng-container matColumnDef="firstName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="firstName"> First Name </th>
                <td mat-cell *matCellDef="let registration"> {{registration.firstName}} </td>
            </ng-container>
            <ng-container matColumnDef="lastName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="lastName"> Last Name </th>
                <td mat-cell *matCellDef="let registration"> {{registration.lastName}} </td>
            </ng-container>
            <ng-container matColumnDef="startingHole">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="startingHole"> Starting Hole </th>
                <td mat-cell *matCellDef="let registration"> {{registration.startingHole}} </td>
            </ng-container>
            <ng-container matColumnDef="teamCaptain">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="teamCaptain"> Team Captain </th>
                <td mat-cell *matCellDef="let registration"> {{registration.teamCaptain}} </td>
            </ng-container>
            <ng-container matColumnDef="hasPaid">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="hasPaid"> Has Paid </th>
                <td mat-cell *matCellDef="let registration">
                    <span class="has-paid-cell">
                        <ng-container *ngIf="!registration.hasPaid">
                            <button mat-stroked-button (click)="pay(registration)">
                                Pay <mat-icon>credit_card</mat-icon>
                            </button>
                        </ng-container>
                        <ng-container *ngIf="registration.hasPaid">
                            <true-false
                                [value]="true"
                                [trueMatIcon]="'price_check'"
                                [trueText]="'Paid'"
                                [fullCellWidth]="true"
                            ></true-false>
                        </ng-container>
                        <span
                            *ngIf="hasRefundGiven(registration)"
                            class="refund-indicator"
                            matTooltip="Refund issued: {{ registration.refundAmount | currency }}"
                            matTooltipPosition="above"
                            aria-label="Refund issued for this registration"
                        >
                            <mat-icon aria-hidden="true">currency_exchange</mat-icon>
                            <span class="refund-indicator__text">Refunded</span>
                        </span>
                    </span>
                </td>
            </ng-container>
            <ng-container matColumnDef="isCheckedIn">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="isCheckedIn"> Is Checked In </th>
                <td mat-cell *matCellDef="let registration">
                    <ng-container *ngIf="!registration.isCheckedIn">
                        <button mat-stroked-button (click)="checkIn(registration)">
                            Check In <mat-icon>how_to_reg</mat-icon>
                        </button>&nbsp;
                    </ng-container>
                    <ng-container *ngIf="registration.isCheckedIn">
                        <true-false [value]="true" [trueMatIcon]="'check_circle_outline'"
                            [trueText]="'Checked In'"></true-false>
                    </ng-container>
                </td>
            </ng-container>
            <ng-container matColumnDef="skins">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="skins"> Skins </th>
                <td mat-cell *matCellDef="let registration">
                    <ng-container *ngIf="!registration.skins">
                        <button mat-stroked-button (click)="updateSkins(registration)">
                            Pay <mat-icon>attach_money</mat-icon>
                        </button>&nbsp;
                    </ng-container>
                    <ng-container *ngIf="registration.skins">
                        <true-false [value]="true" [trueMatIcon]="'price_check'" [trueText]="'Paid'"></true-false>
                    </ng-container>
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let registration">
                    <button mat-icon-button [matMenuTriggerFor]="actionsMenu" *ngIf="canEditOrDelete(registration.startDate)">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #actionsMenu>
                        <button mat-menu-item class="primary" *ngIf="registration.paymentType !== null" (click)="refund(registration)">
                            Refund <mat-icon>currency_exchange</mat-icon>
                        </button>&nbsp;
                        <button mat-menu-item class="secondary"
                            (click)="edit(registration)">
                            Edit <mat-icon>edit</mat-icon>
                        </button>&nbsp;
                        <button mat-menu-item class="warning"
                            (click)="delete(registration)">
                            Delete <mat-icon>delete</mat-icon>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </mat-card>
</div>